export const translations = {
  en: {
    // Nav
    nav_feed: "Feed",
    nav_browse: "Browse",
    nav_live: "Live",
    nav_tokens: "Tokens",
    nav_referrals: "Referrals",
    nav_settings: "Settings",
    nav_admin: "Admin",
    nav_profile: "Profile",

    // Auth
    auth_sign_in: "Sign In",
    auth_sign_up: "Sign Up",
    auth_log_out: "Log Out",
    auth_email: "Email",
    auth_password: "Password",
    auth_confirm_password: "Confirm Password",
    auth_display_name: "Display Name",
    auth_forgot_password: "Forgot Password?",
    auth_no_account: "Don't have an account?",
    auth_have_account: "Already have an account?",
    auth_welcome_back: "Welcome back!",
    auth_login_failed: "Login failed",
    auth_register_success: "Account created!",

    // Landing
    landing_hero_title: "Where Desire Meets Connection",
    landing_hero_subtitle: "The premium adult platform for creators, performers, and passionate communities. Uncensored. Empowering. Yours.",
    landing_get_started: "Get Started",
    landing_browse_free: "Browse Free Content",
    landing_feature_creators: "Creator Tools",
    landing_feature_creators_desc: "Upload content, set subscriptions, and earn 90% of all revenue.",
    landing_feature_live: "Live Streaming",
    landing_feature_live_desc: "Go live with WebRTC streaming, receive tips, and interact in real-time.",
    landing_join_creators: "Join as a Creator",
    landing_creator_split: "90% Revenue Split",
    landing_creator_split_desc: "Industry-leading creator payouts. You create, you earn.",

    // Browse
    browse_title: "Browse",
    browse_trending: "Trending",
    browse_no_trending: "Nothing trending right now",
    browse_subtitle: "Explore free content from across the web",
    browse_load_more: "Load More",
    browse_no_content: "No content found",
    browse_filter: "Filter",
    browse_all_categories: "All Categories",
    browse_showing: "showing",
    browse_of: "of",

    // Tokens
    tokens_title: "Tokens",
    tokens_subtitle: "Purchase tokens to unlock exclusive content",
    tokens_balance: "Your Balance",
    tokens_buy: "Buy Tokens",
    tokens_payment_method: "Payment Method",
    tokens_card: "Credit/Debit Card",
    tokens_card_desc: "Visa, Mastercard, Discover",
    tokens_crypto: "Cryptocurrency",
    tokens_crypto_desc: "BTC, ETH, USDT + 350 more",
    tokens_buy_card: "Buy with Card",
    tokens_buy_crypto: "Buy with Crypto",
    tokens_popular: "Popular",
    tokens_best_value: "Best Value",
    tokens_history: "Transaction History",
    tokens_no_history: "No transactions yet",
    tokens_history_desc: "Your token history will appear here",
    tokens_purchased: "tokens added to your account!",
    tokens_processing: "Payment processing... tokens will be added shortly.",

    // Live Streaming
    live_title: "Live Streams",
    live_go_live: "Go Live",
    live_viewers: "viewers",
    live_no_streams: "No live streams right now",
    live_start_broadcast: "Start Broadcasting",
    live_stop_broadcast: "Stop Broadcasting",
    live_tip: "Tip",
    live_chat: "Chat",
    live_replays: "Replays",
    live_now: "Live Now",
    live_geo_block: "Region Blocking",
    live_geo_block_desc: "Block viewers from specific countries or US states",
    live_blocked_region: "This broadcast is not available in your region",

    // Settings
    settings_title: "Settings",
    settings_account: "Account",
    settings_notifications: "Notifications",
    settings_push: "Push Notifications",
    settings_push_active: "Active",
    settings_push_unsupported: "Not supported in this browser",
    settings_test_push: "Send test notification",
    settings_privacy: "Privacy & Security",
    settings_language: "Language",

    // Referrals
    referrals_title: "Referral Program",
    referrals_subtitle: "Earn 5% commission on every token purchase by your referrals",
    referrals_your_code: "Your Referral Code",
    referrals_share: "Share",
    referrals_total_referred: "Total Referred",
    referrals_total_earned: "Total Earned",

    // Common
    common_loading: "Loading...",
    common_error: "Something went wrong",
    common_save: "Save",
    common_cancel: "Cancel",
    common_delete: "Delete",
    common_edit: "Edit",
    common_close: "Close",
    common_search: "Search",
    common_tokens: "tokens",
    common_free: "Free",
    common_premium: "Premium",
  },

  es: {
    // Nav
    nav_feed: "Inicio",
    nav_browse: "Explorar",
    nav_live: "En Vivo",
    nav_tokens: "Tokens",
    nav_referrals: "Referidos",
    nav_settings: "Ajustes",
    nav_admin: "Admin",
    nav_profile: "Perfil",

    // Auth
    auth_sign_in: "Iniciar Sesión",
    auth_sign_up: "Registrarse",
    auth_log_out: "Cerrar Sesión",
    auth_email: "Correo electrónico",
    auth_password: "Contraseña",
    auth_confirm_password: "Confirmar Contraseña",
    auth_display_name: "Nombre de Usuario",
    auth_forgot_password: "¿Olvidaste tu contraseña?",
    auth_no_account: "¿No tienes una cuenta?",
    auth_have_account: "¿Ya tienes una cuenta?",
    auth_welcome_back: "¡Bienvenido de nuevo!",
    auth_login_failed: "Error al iniciar sesión",
    auth_register_success: "¡Cuenta creada!",

    // Landing
    landing_hero_title: "Donde el Deseo se Encuentra con la Conexión",
    landing_hero_subtitle: "La plataforma premium para creadores, artistas y comunidades apasionadas. Sin censura. Empoderadora. Tuya.",
    landing_get_started: "Comenzar",
    landing_browse_free: "Explorar Contenido Gratis",
    landing_feature_creators: "Herramientas para Creadores",
    landing_feature_creators_desc: "Sube contenido, configura suscripciones y gana el 90% de todos los ingresos.",
    landing_feature_live: "Transmisión en Vivo",
    landing_feature_live_desc: "Transmite en vivo con WebRTC, recibe propinas e interactúa en tiempo real.",
    landing_join_creators: "Únete como Creador",
    landing_creator_split: "90% de Ingresos para Ti",
    landing_creator_split_desc: "Los mejores pagos de la industria. Tú creas, tú ganas.",

    // Browse
    browse_title: "Explorar",
    browse_trending: "Tendencia",
    browse_no_trending: "Nada en tendencia ahora mismo",
    browse_subtitle: "Descubre contenido gratuito de toda la web",
    browse_load_more: "Cargar Más",
    browse_no_content: "No se encontró contenido",
    browse_filter: "Filtrar",
    browse_all_categories: "Todas las Categorías",
    browse_showing: "mostrando",
    browse_of: "de",

    // Tokens
    tokens_title: "Tokens",
    tokens_subtitle: "Compra tokens para desbloquear contenido exclusivo",
    tokens_balance: "Tu Saldo",
    tokens_buy: "Comprar Tokens",
    tokens_payment_method: "Método de Pago",
    tokens_card: "Tarjeta de Crédito/Débito",
    tokens_card_desc: "Visa, Mastercard, Discover",
    tokens_crypto: "Criptomonedas",
    tokens_crypto_desc: "BTC, ETH, USDT + 350 más",
    tokens_buy_card: "Comprar con Tarjeta",
    tokens_buy_crypto: "Comprar con Cripto",
    tokens_popular: "Popular",
    tokens_best_value: "Mejor Valor",
    tokens_history: "Historial de Transacciones",
    tokens_no_history: "Aún no hay transacciones",
    tokens_history_desc: "Tu historial de tokens aparecerá aquí",
    tokens_purchased: "¡tokens añadidos a tu cuenta!",
    tokens_processing: "Procesando pago... los tokens se añadirán en breve.",

    // Live Streaming
    live_title: "Transmisiones en Vivo",
    live_go_live: "Transmitir",
    live_viewers: "espectadores",
    live_no_streams: "No hay transmisiones en vivo ahora",
    live_start_broadcast: "Iniciar Transmisión",
    live_stop_broadcast: "Detener Transmisión",
    live_tip: "Propina",
    live_chat: "Chat",
    live_replays: "Repeticiones",
    live_now: "En Vivo",
    live_geo_block: "Bloqueo Regional",
    live_geo_block_desc: "Bloquea espectadores de países o estados específicos",
    live_blocked_region: "Esta transmisión no está disponible en tu región",

    // Settings
    settings_title: "Ajustes",
    settings_account: "Cuenta",
    settings_notifications: "Notificaciones",
    settings_push: "Notificaciones Push",
    settings_push_active: "Activo",
    settings_push_unsupported: "No compatible con este navegador",
    settings_test_push: "Enviar notificación de prueba",
    settings_privacy: "Privacidad y Seguridad",
    settings_language: "Idioma",

    // Referrals
    referrals_title: "Programa de Referidos",
    referrals_subtitle: "Gana 5% de comisión en cada compra de tokens de tus referidos",
    referrals_your_code: "Tu Código de Referido",
    referrals_share: "Compartir",
    referrals_total_referred: "Total Referidos",
    referrals_total_earned: "Total Ganado",

    // Common
    common_loading: "Cargando...",
    common_error: "Algo salió mal",
    common_save: "Guardar",
    common_cancel: "Cancelar",
    common_delete: "Eliminar",
    common_edit: "Editar",
    common_close: "Cerrar",
    common_search: "Buscar",
    common_tokens: "tokens",
    common_free: "Gratis",
    common_premium: "Premium",
  },
};
